export default function gnavOpen() {
  isOpen();
}

function isOpen() {
  "use strict";

  var acdHeads;

  // マッチしたclass名を持つ要素を取得
  acdHeads = document.querySelectorAll(".navOpen");

  for (var i = 0; i < acdHeads.length; i++) {
    acdHeads[i].addEventListener("click", function() {
      var acdBody;

      // 同じ親要素を持つ隣接した次の要素を取得
      // <div class="acd_menu_body"></div>
      acdBody = this.nextElementSibling;
      acdBody.style.transition = "height 0.2s ease-out";

      if (acdBody.style.height) {
        acdBody.style.height = null;
      } else {
        // scrollHeightプロパティはpaddingを含む表示されていない要素の高さを取得
        acdBody.style.height = acdBody.scrollHeight + "px";
      }
    });
    acdHeads[i].addEventListener("click", ListItemClick, false);
  }
}

function ListItemClick(event) {
  if (this.classList.contains("is-active")) {
    this.classList.remove("is-active");
  } else {
    this.classList.add("is-active");
  }
}
